import { render, staticRenderFns } from "./Question_D.vue?vue&type=template&id=2dc7e703&scoped=true"
import script from "./Question_D.vue?vue&type=script&lang=js"
export * from "./Question_D.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc7e703",
  null
  
)

export default component.exports